<template>
  <RouterView />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useYandexMetrika } from '@/composables/useYandexMetrika'

const router = useRouter()
const { initYandexMetrika, hit } = useYandexMetrika()

onMounted(() => {
  initYandexMetrika()
})

router.afterEach((to, from) => {
  setTimeout(() => {
    hit(to.fullPath, {
      title: document.title,
      from: from?.fullPath
    })
  }, 100)
})
</script>

<style>
/* App-specific styles are now imported through main.css */
</style>